import React from 'react';
const Planification = () => <div>Planification - En construction</div>;
export default Planification;
